// randomizer defaults
export default {
  preset: {
    value: "default",
    name: "randomizer.preset.options.default"
  },
  glitches_required: {
    value: "none",
    name: "randomizer.glitches_required.options.none"
  },
  item_placement: {
    value: "advanced",
    name: "randomizer.item_placement.options.advanced"
  },
  dungeon_items: {
    value: "standard",
    name: "randomizer.dungeon_items.options.standard"
  },
  boss_items: {
    value: "any",
    name: "randomizer.boss_items.options.any"
  },
  drop_shuffle: {
    value: "off",
    name: "randomizer.drop_shuffle.options.off"
  },
  bonk_shuffle: {
    value: "off",
    name: "randomizer.bonk_shuffle.options.off"
  },
  pottery_shuffle: {
    value: "none",
    name: "randomizer.pottery_shuffle.options.none"
  },
  accessibility: {
    value: "items",
    name: "randomizer.accessibility.options.items"
  },
  goal: {
    value: "ganon",
    name: "randomizer.goal.options.ganon"
  },
  tower_open: {
    value: "7",
    name: "randomizer.tower_open.options.7"
  },
  ganon_open: {
    value: "7",
    name: "randomizer.ganon_open.options.7"
  },
  ganon_item: {
    value: "default",
    name: "randomizer.ganon_item.options.default"
  },
  world_state: {
    value: "open",
    name: "randomizer.world_state.options.open"
  },
  entrance_shuffle: {
    value: "none",
    name: "randomizer.entrance_shuffle.options.none"
  },
  door_shuffle: {
    value: "vanilla",
    name: "randomizer.door_shuffle.options.vanilla"
  },
  door_intensity: {
    value: "1",
    name: "randomizer.door_intensity.options.1"
  },
  door_type_mode: {
    value: "original",
    name: "randomizer.door_type_mode.options.original",
  },
  trap_door_mode: {
    value: "vanilla",
    name: "randomizer.trap_door_mode.options.vanilla",
  },
  decouple_doors: {
    value: "off",
    name: "randomizer.decouple_doors.options.off",
  },
  ow_shuffle: {
    value: "vanilla",
    name: "randomizer.ow_shuffle.options.vanilla"
  },
  ow_crossed: {
    value: "vanilla",
    name: "randomizer.ow_crossed.options.vanilla"
  },
  ow_keep_similar: {
    value: "off",
    name: "randomizer.ow_keep_similar.options.off"
  },
  ow_mixed: {
    value: "off",
    name: "randomizer.ow_mixed.options.off"
  },
  ow_flute_shuffle: {
    value: "vanilla",
    name: "randomizer.ow_flute_shuffle.options.vanilla"
  },
  ow_whirlpool_shuffle: {
    value: "vanilla",
    name: "randomizer.ow_whirlpool_shuffle.options.vanilla"
  },
  shopsanity: {
    value: "off",
    name: "randomizer.shopsanity.options.off"
  },
  boss_shuffle: {
    value: "none",
    name: "randomizer.boss_shuffle.options.none"
  },
  enemy_shuffle: {
    value: "none",
    name: "randomizer.enemy_shuffle.options.none"
  },
  hints: {
    value: "on",
    name: "randomizer.hints.options.on"
  },
  weapons: {
    value: "randomized",
    name: "randomizer.weapons.options.randomized"
  },
  item_pool: {
    value: "normal",
    name: "randomizer.item_pool.options.normal"
  },
  item_functionality: {
    value: "normal",
    name: "randomizer.item_functionality.options.normal"
  },
  starting_flute: {
    value: "off",
    name: "randomizer.starting_flute.options.off"
  },
  starting_boots: {
    value: "off",
    name: "randomizer.starting_boots.options.off"
  },
  enemy_damage: {
    value: "default",
    name: "randomizer.enemy_damage.options.default"
  },
  enemy_health: {
    value: "default",
    name: "randomizer.enemy_health.options.default"
  },
  spoiler: {
    value: "on",
    name: "randomizer.spoiler.options.on"
  }
};
